import React, { useState } from "react";
import {
  PositionsTab,
  LatestRecordsTab,
  TransferHistoryTab,
  FollowersTab,
} from "./components";

import "./ActivityPanel.sass";

export const ActivityPanel = () => {
  const mainTabs = [
    "Positions",
    "Latest Records",
    "Transfer History",
    "Follower(s)",
  ];
  const [activeMainTab, setActiveMainTab] = useState(mainTabs[0]);

  const renderActiveTab = () => {
    switch (activeMainTab) {
      case "Positions":
        return <PositionsTab />;
      case "Latest Records":
        return <LatestRecordsTab />;
      case "Transfer History":
        return <TransferHistoryTab />;
      case "Follower(s)":
        return <FollowersTab />;
      default:
        return null;
    }
  };

  return (
    <div className="activity-panel">
      <ul className="activity-panel__main-tabs">
        {mainTabs.map((tab) => (
          <li
            key={tab}
            className={`activity-panel__main-tab ${
              activeMainTab === tab ? "activity-panel__main-tab--active" : ""
            }`}
            onClick={() => setActiveMainTab(tab)}
          >
            {tab}
          </li>
        ))}
      </ul>

      <div className="activity-panel__content">{renderActiveTab()}</div>
    </div>
  );
};
